import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { colors } from '@/lib/analytics/colors';
import { SIZE_25 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const avgViewsRatePerVideoConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.tiktok.average_views_rate_per_video',
    id: 'average_views_rate_per_video',
    icon: {
        name: 'videos',
        style: colors.aquablue
    },
    tooltip: 'kpi.tiktok.tooltip_average_views_rate_per_video',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: DefaultLoader,
    mergedData: true,
    noDataToken: 'analytics:no_data_period',
    element: KPIDefault,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
